import React, { useState, useEffect } from 'react';
import './Sidebar.css';

const Sidebar = (props) => {
  const { walletAddress, onOpenMessages, onOpenDAOGovernance, onOpenProfile, onOpenCosmicForge, onOpenExplore } = props;
  const [phantomWallet, setPhantomWallet] = useState(null);
  
  // Simple wallet check without event listeners to avoid React errors
  useEffect(() => {
    const checkWallet = () => {
      if (window.solana?.isConnected && window.solana?.publicKey) {
        setPhantomWallet(window.solana.publicKey.toString());
      } else {
        setPhantomWallet(null);
      }
    };
    
    checkWallet();
    
    // Check periodically instead of using event listeners
    const interval = setInterval(checkWallet, 1000);
    
    return () => clearInterval(interval);
  }, []);
  
  // Use wallet address from props or detected Phantom wallet
  const effectiveWalletAddress = walletAddress || phantomWallet;
  
  // Debug wallet state (removed excessive logging for performance)
  // console.log('🔍 Sidebar wallet state:', {
  //   propWalletAddress: walletAddress,
  //   phantomWallet: phantomWallet,
  //   effectiveWalletAddress: effectiveWalletAddress
  // });

  const navigationItems = [
    { icon: '🏠', text: 'Home', active: true, onClick: null },
    { icon: '🔍', text: 'Explore', onClick: onOpenExplore },
    { icon: '🔔', text: 'Notifications', onClick: null },
    { icon: '💬', text: 'Messages', onClick: onOpenMessages },
    { icon: '🏛️', text: 'DAO Governance', onClick: onOpenDAOGovernance },
    { icon: '🌌', text: 'Cosmic Forge', onClick: onOpenCosmicForge },
    { icon: '📝', text: 'Lists', onClick: null },
    { icon: '🔖', text: 'Bookmarks', onClick: null },
    { icon: '👤', text: 'Profile', onClick: onOpenProfile },
    { icon: '⚙️', text: 'Settings', onClick: null },
  ];

  const formatAddress = (address) => {
    if (!address) return '';
    return `${address.slice(0, 4)}...${address.slice(-4)}`;
  };
  


  return (
    <div className="sidebar">
      {/* Znoospace Logo */}
      <div className="sidebar-header">
        <div className="logo">
          <span className="logo-icon">🐦</span>
          <span className="logo-text">Znoospace</span>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="sidebar-nav">
        {navigationItems.map((item, index) => (
          <div 
            key={index} 
            className={`nav-item ${item.active ? 'active' : ''} ${item.onClick ? 'nav-item-clickable' : ''}`}
            onClick={item.onClick}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-text">{item.text}</span>
          </div>
        ))}
      </nav>



      {/* Post Button */}
      <div className="post-button-container">
        <button className="post-button">
          <span className="post-icon">✨</span>
          <span className="post-text">Post</span>
        </button>
      </div>

      {/* Connect Wallet Button (if not connected) */}
      {!effectiveWalletAddress && (
        <div className="connect-wallet-section">
          <button 
            className="connect-wallet-button"
            onClick={async () => {
              try {
                console.log('🔗 Connecting to wallet...');
                if (window.solana && window.solana.isPhantom) {
                  // Disconnect first to clear any cached wallet, so Phantom shows the account picker
                  if (window.solana.isConnected) {
                    await window.solana.disconnect();
                  }
                  const response = await window.solana.connect();
                  console.log('✅ Wallet connected successfully:', response.publicKey.toString());
                  setPhantomWallet(response.publicKey.toString());
                  
                  // Trigger page reload to ensure all contexts are updated
                  setTimeout(() => {
                    window.location.reload();
                  }, 500);
                } else {
                  alert('Please install Phantom wallet to continue');
                }
              } catch (error) {
                console.error('❌ Wallet connection failed:', error);
                alert('Failed to connect wallet. Please try again.');
              }
            }}
          >
            <span className="wallet-icon">👛</span>
            <span className="wallet-text">Connect Wallet</span>
          </button>
          <p className="connect-description">
            Connect your Solana wallet to start posting and interacting on Znoospace
          </p>
        </div>
      )}

      {/* Disconnect Wallet Button (if connected) */}
      {effectiveWalletAddress && (
        <div className="sidebar-disconnect">
          <div className="sidebar-wallet-info">
            <span className="wallet-addr">{formatAddress(effectiveWalletAddress)}</span>
          </div>
          <button 
            className="disconnect-wallet-button"
            onClick={async () => {
              try {
                if (window.solana && window.solana.disconnect) {
                  await window.solana.disconnect();
                }
                // Set flag BEFORE clearing so OnboardingContext skips auto-reconnect
                sessionStorage.setItem('znoospace_user_disconnected', 'true');
                localStorage.clear();
                setTimeout(() => window.location.reload(), 500);
              } catch (error) {
                console.error('❌ Disconnect error:', error);
                localStorage.clear();
                window.location.reload();
              }
            }}
            title="Disconnect wallet and switch accounts"
          >
            <span className="disconnect-icon">🔌</span>
            <span>Disconnect</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
